export default __webpack_public_path__ + "static/media/gift.e31e6d31.png";